"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduleInfoItemsCreatorTexts = void 0;
require("../../../core");
require("../types");
const getScheduleInfoItemsCreatorTexts = (t) => {
    return {
        storageClassLabel: t('scheduleInfo|form|fields|repository|storageClassLabel'),
        repositoryLabel: t('scheduleInfo|form|fields|repository|label'),
        unitsLabelDaysSingular: t('scheduleInfo|unitsLabel|days|singular'),
        unitsLabelDaysPlural: t('scheduleInfo|unitsLabel|days|plural'),
        unitsLabelMonthsSingular: t('scheduleInfo|unitsLabel|months|singular'),
        unitsLabelMonthsPlural: t('scheduleInfo|unitsLabel|months|plural'),
        unitsLabelYearsSingular: t('scheduleInfo|unitsLabel|years|singular'),
        unitsLabelYearsPlural: t('scheduleInfo|unitsLabel|years|plural'),
        dailyScheduleRowFirstSecondFilledLabel: t('scheduleInfo|form|fields|row|first|filled|daily'),
        dailyScheduleRowThirdFilledLabel: t('scheduleInfo|form|fields|row|thirds|filled|daily'),
        weeklyScheduleRowFirstSecondFilledLabel: t('scheduleInfo|form|fields|row|first|filled|weekly'),
        weeklyScheduleRowThirdFilledLabel: t('scheduleInfo|form|fields|row|thirds|filled|weekly'),
        monthlyScheduleRowFirstSecondFilledLabel: t('scheduleInfo|form|fields|row|first|filled|monthly'),
        monthlyScheduleRowThirdFilledLabel: t('scheduleInfo|form|fields|row|thirds|filled|monthly'),
        scheduleRowAnyDisabled: t('scheduleInfo|form|labels|disabled'),
        scheduleRowAnyEmptyLabel: t('scheduleInfo|form|labels|empty'),
        scheduleRowThirdExcludedStr: t('scheduleInfo|form|fields|row|thirds|excludedStr'),
        restorePointTimeLabel: t('scheduleInfo|form|fields|restorePointTime'),
    };
};
exports.getScheduleInfoItemsCreatorTexts = getScheduleInfoItemsCreatorTexts;
//# sourceMappingURL=getScheduleInfoItemsCreatorTexts.js.map